import React, { type CSSProperties } from 'react'

import { X } from '@doist/icons/brand'
import { Box, Button, Divider, Text } from '@doist/marketist'

import { Dialog, DialogHeading, type DialogStore, useDialogContext } from '@ariakit/react'
import cn from 'clsx'

import css from './modal.module.css'

export type ModalProps = {
    title?: string
    store?: DialogStore
    children: React.ReactNode
    buttons?: React.ReactNode[]
    width?: string
}
export function Modal({ title, store, width, children, buttons }: ModalProps) {
    const dialogStore = useDialogContext() || store

    if (!dialogStore) {
        throw new Error('Modal must be used within a DialogProvider or have a store provided')
    }

    return (
        <Dialog
            store={store}
            className={css.popup}
            backdrop={<div className={css.backdrop} />}
            style={{ '--popup-inline-size': width } as CSSProperties}
        >
            <Box className={cn(css.modal, 'pb-12 pi-12')}>
                <DialogHeading className={css.heading}>
                    {title ? <Text size="major-sm">{title}</Text> : null}
                    <Button
                        startIcon={X}
                        variant="secondary"
                        onClick={dialogStore.hide}
                        size="base"
                    />
                </DialogHeading>
                {children}
                {buttons && buttons.length > 0 ? (
                    <Box className={css.actions}>
                        <Divider />
                        {buttons}
                    </Box>
                ) : null}
            </Box>
        </Dialog>
    )
}
